<template>
  <v-container grid-list-xl class="pa-0">
    <v-layout wrap>
      <v-flex xs12>
        <m-card-list
          two-line
          title="Operator"
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @change:page="(pg)=>{cp=pg;load()}"
          @add="add"
        >
          <template v-slot:items="{props,item}"><tr>
            <td>
              <m-labelicon icon="mdi-account" avatar-color="grey" :avatar-size="40" :icon-size="30">
                <div>
                  <div class="block subtitle-1">
                    <router-link
                      class="ok"
                      :to="{name:'user.operator', params:{user_id:item.user_id}}"
                    >{{item.nama}}</router-link>
                  </div>
                </div>
              </m-labelicon>
            </td>
            <td>{{item.email}}</td>
            <td>{{item.no_hp}}</td>
            <td>{{item.gender}}</td>
            <td>
              <m-menu left style="float:right" :items="more_menu" :object="item"/>
            </td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
export default {
  components: {
    BlockCard,
  },
  data() {
    return {
      menu: false,
      items: [],
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Surel", align: "left", value: "email" },
        { text: "No HP", align: "left", value: "no_hp" },
        { text: "Gender", align: "left", value: "gender" },
        { text: "", sortable: false }
      ],
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Set User",
          click: this.setUser,
          // check: (i, o) => o.k_status == this.$wisata.STATUS_AKTIF
        },
        { divider: true },
        {
          title: "Ubah",
          click: (i, o) =>
            this.edit(o)
        },
        {
          title: "Hapus",
          click: (i, o) =>
            this.delete(o)
        }
      ]
    };
  },
  computed: {},
    mounted() {
    this.load();
  },
    methods: {
    load() {
      this.$store
        .dispatch("user/getOperator", { page: this.cp })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
     setUser(item, obj) {
      this.$confirmDanger(
        `Apakah anda yakin akan mengubah role sebagai User?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${obj.nama}
        </div>
        `
      )
        .then(() => this.$store.dispatch("user/gantiRole", {user_id : obj.user_id,role: 'user'}))
        .then(() => this.load())
        .catch(e => e);
    },
    hapus(item) {
      this.$confirmDanger(
      `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">
          
            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>
            
          <div class="col m11">
          Anda juga akan menghapus seluruh data Organisasi pada Tenant ini.
          Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>
        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      )
        .then(() => this.$store.dispatch("operator/drop", item.no_reg))
        .then(() => {
          this.$info('Data operator berhasil dihapus')
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
